import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
/**
 * 'blurH' -> ['blurH', {}]
 */
export function normalizePasses(passes) {
  return passes.map(function (pass) {
    if (typeof pass === 'string') {
      pass = [pass, {}];
    }
    return pass;
  });
}

/**
 * 默认添加 ClearPass、RenderPass
 * 以及 PostProcessing 中的最后一个 CopyPass
 */
export function createMultiPassRenderer(layer, passes, postProcessingPassFactory, normalPassFactory) {
  var multiPassRenderer = layer.multiPassRenderer;
  var _layer$getLayerConfig = layer.getLayerConfig(),
    enableTAA = _layer$getLayerConfig.enableTAA;

  // picking pass if enabled
  // if (enablePicking) {
  //   multiPassRenderer.add(normalPassFactory('pixelPicking'));
  // }

  // use TAA pass if enabled instead of render pass
  if (enableTAA) {
    multiPassRenderer.add(normalPassFactory('taa'));
  } else {
    // render all layers in this pass
    multiPassRenderer.add(normalPassFactory('render'));
  }

  // post processing
  normalizePasses(passes).forEach(function (pass) {
    var _pass = _slicedToArray(pass, 2),
      passName = _pass[0],
      initializationOptions = _pass[1];
    multiPassRenderer.add(postProcessingPassFactory(passName), initializationOptions);
  });

  // 末尾为固定的 CopyPass
  multiPassRenderer.add(postProcessingPassFactory('copy'));
  return multiPassRenderer;
}